import { type UseQueryResult, useQuery } from 'react-query';
import {
  DashboardService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_Dashboard_ParticipantTaskResponseDto,
} from '../../services/wealthlane-award-services';

const useGetParticipantDashboardTaskSummery = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
  //   isOnBoarded?: boolean
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_Dashboard_ParticipantTaskResponseDto | undefined,
  unknown
> => {
  const participantDashboardTaskSummery = useQuery(
    ['getParticipantDashboardTaskSummery'],
    async () => {
      //   if (isOnBoarded) {
      return await handleRequest(
        DashboardService.getApiAwardApiAppDashboardParticipantTaskSummary()
      );
    }
    // }
  );
  return participantDashboardTaskSummery;
};

export default useGetParticipantDashboardTaskSummery;
